import { me } from '../../const';
import { PermeatorPlatform } from '../PermeatorExt';

const p: PermeatorPlatform = {
    push(url:string) {
        me.location.href = url;
    },
    open(url:string) {
        me.open(url);
    },
    close() {
        me.close();
    },
    relogin(homeUrl:string) {
        if (window.opener) {
            window.opener.postMessage({
                $type: 'closeOpener',
                homeUrl,
                activeUrl: window.location.href
            }, '*');
        }
        window.location.replace(homeUrl);
    }
};

export default p;
